var app = angular.module('tractive', []);
app.service('tractive', function() {
    this.track = function (billingTeam, eventName, attributes) {
      var tractive = window.tractive;
      if (tractive && typeof tractive.track === 'function') {
        tractive.track(billingTeam, eventName, attributes);
      }
    }
});